import { baseTheme } from '~base-theme';
var authTheme = {
  auth: {
    divider: {
      color: baseTheme.base.grays.grayLighter
    },
    container: {
      maxWidth: 360
    }
  }
};
export default authTheme;